const language = {
	spanish: {
		header_title: "Alianzas ",
		header_span_title: "Claves",
		alianza_yellow_title: "Alianzas Claves",
		alianza_bold_title:
			"En Foresight GPS estamos comprometidos con prestar el mejor servicio a nuestro clientes y asociados, es por ello que contamos con alianzas claves de clase mundial que garantizan nuestra calidad de servicio",
		microsoft_yellow_title: "Microsoft Azure",
		microsoft_bold_text:
			"La plataforma Azure está compuesta por más de 200 productos y servicios en la nube diseñados para ayudarle a dar vida a nuevas soluciones que permitan resolver las dificultades actuales y crear el futuro.",
		microsoft_text: [
			"Cree, ejecute y administre aplicaciones en varias nubes, en el entorno local y en el perímetro, con las herramientas y los marcos que prefiera.",
			"Con el respaldo de la marca del gigante tech Microsoft, Azure es nuestra solución en la nube para hacer que todos nuestros desarrollos tenga el mejor rendimiento y la mayor seguridad",
		],
		google_yellow_text: "Google Maps API",
		google_bold_text:
			"Cualquier aplicación de geolocalización sin la integración de mapas y productos de Google Maps está incompleta. En todos los desarrollos de Foresight GPS hay una robusta integración con los productos de Google Maps para hacer más completas todas nuestras aplicaciones.",
	},
	english: {
		header_title: "Key ",
		header_span_title: "Alliances",
		alianza_yellow_title: "Key Alliances",
		alianza_bold_title:
			"At ForesightGPS we are committed to providing the best service to our clients and associates, and with our world-class alliances we guarantee our quality of service.",
		microsoft_yellow_title: "Microsoft Azure",
		microsoft_bold_text:
			"The Azure platform contains more than 200 cloud products and services, designed to help you bring new solutions to solve today’s challenges and create in the future.",
		microsoft_text: [
			"Build, run, and manage apps across multiple clouds, on-premises, and at the edge, with the tools and frameworks of your choice.",
			"With the support of the tech giant Microsoft, Azure is our solution in the cloud to make our developments have the best performance and the highest security.",
		],
		google_yellow_text: "Google Maps API",
		google_bold_text:
			"Any geolocation app without the integration of maps and Google Maps is incomplete. In all ForesightGPS developments there is a robust integration with Google Maps products to make our apps more complete.",
	},
};

export default language;